import LeadMagnetPage from '../components/LeadMagnetPage'

export default function JobSeekerLeadMagnet() {
  return <LeadMagnetPage type="jobSeeker" />
}
